<template>
  <div class="pic_bg">
    <header>
      <el-image :src="iconHeader"></el-image>
      <span class="title_font">{{ titleName }}</span>
    </header>
    <body>
      <el-tag effect="dark" class="btn-h" color="#397b3e" @click="goPage('HistoryRecord')">
        浏览记录
      </el-tag>
      <el-tag effect="dark" class="btn-h" color="#397b3e" @click="goPage('ExaminationResults')">
        考试结果查询
      </el-tag>
      <el-tag effect="dark" class="btn-h" color="#397b3e" @click="getUserInfo">
        个人信息
      </el-tag>
      <el-tag effect="dark" class="btn-h" color="#397b3e" @click="updatePassword">
        密码修改
      </el-tag>

      <el-table
        :data="list"
        style="width: 100%">
        <el-table-column
          prop="broweUser"
          label="用户">
        </el-table-column>
        <el-table-column
          prop="broweTypename"
          label="类型">
        </el-table-column>
        <el-table-column
          prop="broweContentName"
          label="名称">
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="访问时间">
        </el-table-column>
      </el-table>
      <div class="page">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 50]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </body>

    <el-dialog
      title="修改密码"
      :visible.sync="dialogVisible"
      width="40%"
      @close="close">
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input type="password" v-model="form.oldPassword"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input type="password" v-model="form.newPassword"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="newPassword2">
          <el-input type="password" v-model="form.newPassword2"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="upPassSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="个人信息"
      :visible.sync="dialogVisible2"
      width="40%"
    >
      <el-form :model="userInfo" label-width="80px">
        <el-form-item label="用户名:">
          <el-input
            v-model="userInfo.userName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号:">
          <el-input
            v-model="userInfo.phonenumber"
            autocomplete="off"
          ></el-input> </el-form-item
        >
        <el-form-item label="性别:">
          <el-select v-model="userInfo.sex" style="width:100%;">
            <el-option label="男" value="0"></el-option>
            <el-option label="女" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="邮箱:">
          <el-input
            v-model="userInfo.email"
            autocomplete="off"
          ></el-input> </el-form-item
        >
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="userSubmit">修 改</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getBrowerecord, updatePwd, getUserInfos, upUserInfo } from '@/network/api.js'

export default {
  data() {
    const equalToPassword = (rule, value, callback) => {
      if (this.form.newPassword !== value) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    };
    return {
      titleName: '个人中心',
      iconHeader: require("@/assets/images/pageico_4.png"),
      dialogVisible: false,
      dialogVisible2: false,
      form: {
        oldPassword: '',
        newPassword: '',
        newPassword2: '',
      },
      userInfo: {},
      rules: {
        oldPassword: [
          { required: true, message: "旧密码不能为空", trigger: "blur" }
        ],
        newPassword: [
          { required: true, message: "新密码不能为空", trigger: "blur" },
          { min: 6, max: 20, message: "长度在 6 到 20 个字符", trigger: "blur" }
        ],
        newPassword2: [
          { required: true, message: "确认密码不能为空", trigger: "blur" },
          { required: true, validator: equalToPassword, trigger: "blur" }
        ]
      },
      list: [],
      total: 0,
      pageNum: 1,
      pageSize: 10
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    userSubmit() {
      upUserInfo({
        nickName: this.userInfo.userName,
        phonenumber: this.userInfo.phonenumber,
        email: this.userInfo.email,
        sex: this.userInfo.sex
      }).then(res => {
        if (res.code == 200) {
          this.$message.success('修改成功!')
        } else {
          this.$confirm(res.msg, '修改失败', {
            confirmButtonText: '确定',
            type: 'error'
          })
        }
      })
    },
    getUserInfo() {
      this.dialogVisible2 = true;
      getUserInfos().then(res => {
        this.userInfo = res.data;
      })
    },
    goPage(val) {
      this.$router.push(val)
    },
    updatePassword() {
      this.dialogVisible = true;
    },
    upPassSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          updatePwd({
            oldPassword: this.form.oldPassword,
            newPassword: this.form.newPassword,
          }).then(res => {
            if (res.code == 200) {
              this.$message.success('密码修改成功!');
              this.dialogVisible = false;
            } else {
              this.$confirm(res.msg, '密码修改失败', {
                confirmButtonText: '确定',
                type: 'error'
              })
            }
          })
        }
      })
      
    },
    init() {
      this.queryHistory()
    },
    queryHistory() {
      getBrowerecord({
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }).then(res => {
        this.list = res.rows;
        this.total = res.total;
      })
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.queryHistory()
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryHistory()
    },
    close() {
      this.form = {
        oldPassword: '',
        newPassword: '',
        newPassword2: '',
      }
    }
  }
}
</script>

<style scoped>
.pic_bg {
  width: 1150px;
  margin: 0 auto;
}
header {
  width: 1150px;
  display: flex;
  margin-bottom: 6px;
  align-items: center;
}
body {
  width: 1150px;
  margin-top: 12px;
  margin-bottom: 12px;
  min-height: 100px;
}
.title_font {
  color: #397b3e;
  font-size: 20px;
  margin-left: 6px;
}
.btn-h:hover {
  cursor: pointer;
}
.page {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/PersonalCenter.vue